<div class="modal-header">
    <h4 class="modal-title"
        [innerHtml]="('BATCH_LEVEL_AFFECTATION'|translate)"></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="filter-for-list">

    <div class="current-level">{{'MOVE_LEVEL_FROM_HEADER'|translate}} <strong> {{ getCurrentLevelName() }} </strong> {{'TO'|translate}}
        <mat-icon class="arrow-parent">play_arrow
        </mat-icon>
        <mat-icon class="arrow-parent">play_arrow
        </mat-icon>
        <mat-icon class="arrow-parent">play_arrow
        </mat-icon>
    </div>
    <mat-form-field>
        <mat-select [(value)]="levelId" [placeholder]="'LEVELS_SELECT_TOOLTIP'|translate">
            <mat-option *ngFor="let level of levelsDropList" [value]="level.id">
                {{level.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <button class="btn top-list-tools" placement="left"
            [ngbTooltip]="'MOVE_DEVICE_TOOLTIP' | translate" (click)="patchDeviceCollection()">
        <fa-icon [icon]="faExchangeAlt"></fa-icon>
        {{'BATCH_LEVEL_AFFECTATION'|translate}}
    </button>

    <br clear="both"/>
</div>

<app-progressbar *ngIf="showSpinner"></app-progressbar>

<table mat-table [dataSource]="devices" matSort class="table-striped" style="width:100%">

    <ng-container matColumnDef="device_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
        <td mat-cell *matCellDef="let device">
            <mat-chip>{{device.device_type|translate}}
            </mat-chip>

        </td>
    </ng-container>


    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let device"><b>{{device.id}}</b>
        </td>
    </ng-container>


    <ng-container matColumnDef="device">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE'|translate}}</th>
        <td mat-cell *matCellDef="let device">

            <mat-chip-list style="display:inline-block;">
                <mat-chip matBadgePosition="below after" matBadgeColor="accent"
                          [matBadge]="device.channel"
                          [removable]="true">
                    <span>{{device.device_type|translate}}</span>
                    <span class="inner-badge" *ngIf="device.unit">{{device.unit.value|translate}}</span>
                    <span class="inner-badge-length" *ngIf="device.length">{{device.length}}m</span>
                </mat-chip>

            </mat-chip-list>
            <span class="linkInListPrincipal">{{device.uid}} </span>
        </td>
    </ng-container>


    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let device">
            <mat-icon style="color:red;cursor:pointer" (click)="removeDevice(device.id)"
                      matTooltipPosition="right"
                      [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
            </mat-icon>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="20"
></mat-paginator>

<div class="modal-footer">

    <button type="button" class="btn btn-light" (click)="activeModal.close('Close click')"
            [innerHTML]="'CLOSE' | translate">Close
    </button>
</div>